import(/* webpackMode: "eager" */ "/app/front_end/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/front_end/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["CoherenceLinksProvider"] */ "/app/front_end/src/app/(main)/components/coherence_links_provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/components/comments_feed_provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopChromeHeaderSetter"] */ "/app/front_end/src/app/(main)/components/top_chrome_header_context.tsx");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/app/(main)/questions/[id]/components/key_factors/key-factors.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/notebook_redirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/question_embed_modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/question_page_shell/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/sidebar/sidebar_question_info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/[id]/components/sidebar/similar_questions/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/front_end/src/components/post_card/community_disclaimer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/contexts/cp_context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmbedModalContextProvider"] */ "/app/front_end/src/contexts/embed_modal_context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExperimentsProvider"] */ "/app/front_end/src/contexts/experiments_context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostSubscriptionProvider"] */ "/app/front_end/src/contexts/post_subscription_context.tsx");
